import type { McpClientId } from "@arcadeai/ui-kit/mcp-gateway-connect";

// Cursor's universal link decodes its query as form data, so spaces must be
// `+` rather than the `%20` that encodeURIComponent emits.
const ENCODED_SPACE = /%20/g;

const PROMPT_DEEP_LINK_SCHEMES: Partial<
  Record<McpClientId, { maxChars: number; build: (encoded: string) => string }>
> = {
  cursor: {
    maxChars: 8000,
    // Universal link (https) — redirects into the app with the prompt
    // prefilled, matching the share links Cursor itself generates.
    build: (text) =>
      `https://cursor.com/link/prompt?text=${text.replace(ENCODED_SPACE, "+")}`,
  },
  claude_desktop: {
    maxChars: 14_000,
    build: (q) => `claude://claude.ai/new?q=${q}`,
  },
  claude_code: {
    maxChars: 5000,
    build: (q) => `claude-cli://open?q=${q}`,
  },
};

/**
 * Deep link that opens the connected client with a prefilled prompt, used by
 * the onboarding "get to work" CTAs. Returns null for clients without a known
 * prompt deep-link scheme.
 */
export function buildPromptDeepLink(
  clientId: McpClientId,
  prompt: string
): string | null {
  const scheme = PROMPT_DEEP_LINK_SCHEMES[clientId];
  if (!scheme) {
    return null;
  }
  return scheme.build(encodeURIComponent(prompt.slice(0, scheme.maxChars)));
}
